import t from "./_overArg.js";
var e = t(Object.getPrototypeOf, Object);
const r = e;
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getPrototype.js
// module id = 443
// module chunks = 41